import { Plus } from '@phosphor-icons/react';
import { observer } from 'mobx-react';
import { TinkerBoxQueryMode } from '../../api/queries/tinkerBoxes';
import { HomeStore } from '../../stores/HomeStore';
import { TinkerBoxes } from '../TinkerBoxes';

export interface TinkerBoxSectionProps {
  store: HomeStore;
  onLaunch?: () => void;
  mode: TinkerBoxQueryMode;
  hideIpAddress?: boolean;
}

export const TinkerBoxSection = observer((props: TinkerBoxSectionProps) => {
  return (
    <div
      className="w-full h-full overflow-hidden flex flex-col gap-2"
      data-tour="tinkerboxes"
    >
      <div className="flex justify-between">
        <h2>tinkerboxes</h2>
        {props.onLaunch && (
          <button
            className="cursor-auto"
            data-tour="launch-tinkerbox"
            onClick={async () => {
              if (props.store.selectedLabId) {
                return;
              }
              props.onLaunch?.();
            }}
          >
            <Plus
              size={20}
              className="hover:cursor-pointer hover:scale-110 transition-transform"
            />
          </button>
        )}
      </div>
      <div className="w-full h-full overflow-auto flex-grow">
        <TinkerBoxes
          hideIpAddress={props.hideIpAddress}
          onStop={() => {}}
          onConnect={(id: number | null) => {
            if (id) {
              props.store.connectToTinkerBoxWhenAvailable(id);
            } else {
              props.store.connectToTinkerbox(null);
            }
          }}
          store={props.store}
        />
      </div>
    </div>
  );
});
